export const V3_RECOMMENDATIONS_RUNTIME_NAME = '/v3/get-recommendations-microfrontend/';
